import { logGeneralError } from '../../utils/sentry';

interface OnClickHandlerParams {
  onClick?: () => any | unknown;
  logErrorParams: {
    message: string;
    fingerprint: string[];
  };
}

export const onClickHandler =
  ({ onClick, logErrorParams }: OnClickHandlerParams) =>
  async (): Promise<{ canceled: boolean }> => {
    if (typeof onClick === 'function') {
      try {
        const r = await Promise.resolve(onClick());
        return r;
      } catch (e) {
        logGeneralError({
          payload: {
            plainError: JSON.stringify(e),
          },
          message: logErrorParams.message,
          fingerprint: logErrorParams.fingerprint,
        });
        return { canceled: true };
      }
    }
    return { canceled: false };
  };
